import { render, staticRenderFns } from "./FormInputs.vue?vue&type=template&id=c4e08a3a"
import script from "./FormInputs.vue?vue&type=script&lang=js"
export * from "./FormInputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BasicText: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/basic/BasicText.vue').default,FormFieldSelectButton: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/form/FormFieldSelectButton.vue').default,FormFieldCheckbox: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/form/FormFieldCheckbox.vue').default,FormFieldSelectImage: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/form/FormFieldSelectImage.vue').default,FormFieldSlider: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/form/FormFieldSlider.vue').default,FormFieldCalendar: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/form/FormFieldCalendar.vue').default,FormFieldInput: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/form/FormFieldInput.vue').default,FormFieldTextArea: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/form/FormFieldTextArea.vue').default,FormFieldUpload: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/form/FormFieldUpload.vue').default})
